module.exports = __webpack_public_path__ + "e54fdbddbd0b9ef5beab27f3f4ecc510.jpg";